import React, { useState, useEffect, useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CustomPagination from '../../components/company_panel/common/custompagination'
import { capitalizeFirstLetter, checkPermission, formateDate, getBrandId, getOutletId, getExcelColumnWidths } from '../../helpers/commonFunctions';
import Sorting from '../../components/company_panel/common/sorting';
import Loader from '../../components/company_panel/common/loader'
import StatusFilter from '../../components/company_panel/common/statusFilter'
import {  LOADER_TIME, showFilterlist } from '../../utils/Constants'
import CustomRangepicker from '../../components/company_panel/common/rangepicker'
import $ from "jquery";
import { getCompany } from '../../helpers/commonFunctions';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import notFound from '../../assets/company/img/no-record-found.png'
import { CustomerDelete, ListCustomer } from '../../services/company_panel/customer.services';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import GlobalLoader from '../../components/company_panel/common/globalLoader';
import { usePersistedListState } from '../../hooks/usePersistedListState';


const CustomerList = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    // persisted filters (page lives in the route) — restored on return from view
    const { saved, save, clear } = usePersistedListState('customers');
    const [list, setList] = useState([])
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10)
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState(saved?.search || {})
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "")
    const [resetdate, setResetDate] = useState(false);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        });
    });

    useEffect(() => {
        if (search) {
            setLoader(true)
            setTimeout(() => {
            const formData = new FormData()
            formData.append("page", page)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append('company_id', getCompany().company_id); 
            ListCustomer(formData).then(data => {
                setDataLength(data.data.response.count);
                setList(data && data.data && data.data.response ? data.data.response.rows : [])
                    setLoader(false);
            }).catch(error => {
                console.log("error ====> ", error);
                    setLoader(false);
            })
        }, 500);
        }
    }, [location, statsUpdate, sorting, search, globalSearch,isBrandChanged, isOutletChanged])

    // persist filters on every change (page lives in the route, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])


    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        clear()
    }

    const viewFunction = (row) => {
        navigate(`/company/crm/customers/view/${row}?page=${page}`)
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

    const headerMapping = {
        "id": "Id",
        "customer_name": "Name",
        "customer_number": "Phone Number",
        "customer_address": "Address",
        "loyalty_points" : "Loyalty Points",
        "created_at": "Created At"
    };

    const formatValue = (value) => {
        if (value === null || value === undefined || value === "") {
            return 'N/A';
        }
        return value.toString().replace(/_/g, ' ');
    };
    const handleExport = () => {
        setGlobalLoader(true)
        const formData = new FormData()
        formData.append("page", 1);
        formData.append("per_page", dataLength);
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id); 
        ListCustomer(formData).then(data => {
        const listData = data && data.data && data.data.response ? data.data.response.rows : [];
        const printData = listData.map((item) => {
            const transformedItem = {};
            const customerName = item.customer_name && item.customer_name ? item.customer_name : 'N/A';
            const customerAddress = item.customer_address && item.customer_address ? item.customer_address : 'N/A';
            const loyaltyPoints = item.loyalty_points && item.loyalty_points ? item.loyalty_points : 'N/A';
            for (const key in headerMapping) {
                if (headerMapping.hasOwnProperty(key)) {
                    const newKey = headerMapping[key];
                    if (key === "customer_name") {
                        transformedItem[newKey] = capitalizeFirstLetter(customerName);
                    }
                    if (key === "customer_address") {
                        transformedItem[newKey] = capitalizeFirstLetter(customerAddress);
                    }
                    if (key === "loyalty_points") {
                        transformedItem[newKey] = (loyaltyPoints);
                    }
                    if (key === "created_at") {
                        transformedItem[newKey] = formateDate(item.created_at);
                    }
                    else {
                        transformedItem[newKey] = formatValue(item[key]);
                    }
                }
            }
            return transformedItem;
        });
        const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
        ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'customer.xlsx');
        // setTimeout(() => {
        //     setLoader(false);
        // }, LOADER_TIME);
        setGlobalLoader(false)
    }).catch(error => {
        // setTimeout(() => {
        //     setLoader(false);
        // }, LOADER_TIME);
        console.log("error ====> ", error);
        setGlobalLoader(true)
    })
    };

    function deleteFunction(row) {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "Please note that if you delete this, all related loyalty points and orders will also be delete and cannot be restored!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const formdata = new FormData()
                formdata.append("id", row)
                CustomerDelete(formdata).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: 'Customer deleted successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("deleteError")
                })
            }
        })
    }


    return (
        <>
            {globalLoader && <GlobalLoader />}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Customers</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                            <button  onClick={handleExport} className="btn btn-primary ms-2">Export Customer</button>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20'>
                        <div className='filter-header d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="date-input">
                                    <CustomRangepicker GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="25%">
                                            <div className='sorting_column'>
                                                <span>ID</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="idss" />
                                            </div>
                                        </th>
                                        <th width="25%">
                                            <div className='sorting_column'>
                                                <span>Name</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="customer_name" />
                                            </div>
                                        </th>
                                        <th width="25%">
                                            <div className='sorting_column'>
                                                <span>Phone</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="customer_number" />
                                            </div>
                                        </th>
                                        {/* <th width="25%">
                                            <div className='sorting_column'>
                                                <span>Address</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="customer_address" />
                                            </div>
                                        </th> */}
                                        <th width="25%">
                                            <div className='sorting_column'>
                                                <span>Loyalty Points</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="loyalty_points" />
                                            </div>
                                        </th>
                                        <th className="created_head" width="25%">
                                            <div className='sorting_column'>
                                                <span>Created Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                            </div>
                                        </th>
                                        <th className='action_head text-end' width="25%">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={12}>
                                                <Loader />
                                            </td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{row?.id ? '#' + (row?.id) : 'N/A'}</td>
                                                    <td>{row?.customer_name ? capitalizeFirstLetter(row?.customer_name) : 'N/A'}</td>
                                                    <td>{row?.customer_number ? row?.customer_number : '-'}</td>
                                                    <td>{row?.loyalty_points ? row?.loyalty_points : '-'}</td>
                                                    {/* <td>{row?.customer_address ? capitalizeFirstLetter(row?.customer_address) : 'N/A'}</td> */}
                                                    <td>{row.created_at ? formateDate(row?.created_at) : "N/A"}</td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                            {checkPermission('store_customers', 'view') ?
                                                                <li><div className='dropdown-item' onClick={() => { viewFunction(row.id) }}><i className="ti ti-eye" aria-hidden="true"></i> View details</div></li>
                                                                : '' }
                                                                {checkPermission('store_customers', 'delete') ?
                                                                <li> <div className='dropdown-item' onClick={() => { deleteFunction(row.id) }}><i className="ti ti-trash" aria-hidden="true"></i> Delete</div></li>
                                                                : '' }
                                                                </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={6} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No records</p>
                                                </td>
                                            </tr>}
                                        </>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "customer", path: "/company/crm/customers/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                hideProgressBar={false}
                autoClose={true | 1000}
                newestOnTop={true}
                closeOnClick={false}
                draggable={false}
                rtl={false}
            />
        </>
    );
}

export default CustomerList